import type { ApplicationConfig } from '@angular/core';
import { inject, provideAppInitializer } from '@angular/core';
import { ErrorHandler, importProvidersFrom } from '@angular/core';
import { provideRouter, Router, TitleStrategy, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorInterceptor } from './core/services/api/interceptors/error-intorceptor';
import { createErrorHandler } from './app.error-handler';
import { AppTitleStrategy } from './core/services/app-title-strategy';
import { WINDOW, windowProvider } from './core/providers/window';
import { DOCUMENT } from '@angular/common';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import * as Sentry from '@sentry/angular';
import { ToastrModule } from 'ngx-toastr';

const initializeApp = async () => {
  // Do some asynchronous stuff
  return;
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimations(),
    importProvidersFrom(MatDialogModule),
    importProvidersFrom(
      ToastrModule.forRoot({
        timeOut: 4000,
        closeButton: true,
        positionClass: 'toast-top-center',
        preventDuplicates: true,
      }),
    ),
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { autoFocus: false, disableClose: true } },
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    {
      provide: WINDOW,
      useFactory: (document: Document) => windowProvider(document),
      deps: [DOCUMENT],
    },
    {
      provide: MAT_RADIO_DEFAULT_OPTIONS,
      useValue: { color: 'primary' },
    },
    {
      provide: ErrorHandler,
      useFactory: () => createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
      return initializeApp();
    }),
  ],
};
